var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCreditCard = function SvgCreditCard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.464 33.044h26.724A2.813 2.813 0 0 0 38 30.23v-15.94a2.813 2.813 0 0 0-2.813-2.813H8.465a2.813 2.813 0 0 0-2.812 2.813v15.94a2.813 2.813 0 0 0 2.812 2.813Z",
    fill: "#256B61"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38 15.521H5.652v5.392H38V15.52Z",
    fill: "#194741"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.566 27.37a.656.656 0 0 0 .656.657h8.087a.656.656 0 0 0 0-1.312h-8.087a.656.656 0 0 0-.656.656Z",
    fill: "url(#Credit_Card_svg__a)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.914 23.327a.656.656 0 1 0-1.312 0 .656.656 0 0 0 1.312 0Z",
    fill: "url(#Credit_Card_svg__b)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26.261 23.327a.656.656 0 1 0 1.312 0 .656.656 0 0 0-1.312 0Z",
    fill: "url(#Credit_Card_svg__c)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M28.957 23.327a.656.656 0 1 0 1.312 0 .656.656 0 0 0-1.312 0Z",
    fill: "url(#Credit_Card_svg__d)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M31.653 23.327a.656.656 0 1 0 1.312 0 .656.656 0 0 0-1.312 0Z",
    fill: "url(#Credit_Card_svg__e)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M31.536 7H4.813A2.813 2.813 0 0 0 2 9.813v15.94a2.813 2.813 0 0 0 2.813 2.813h26.723a2.813 2.813 0 0 0 2.813-2.813V9.813A2.813 2.813 0 0 0 31.536 7Z",
    fill: "url(#Credit_Card_svg__f)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M26.261 23.327a3.039 3.039 0 0 1 1.204-2.417 3.027 3.027 0 1 0 0 4.834 3.028 3.028 0 0 1-1.204-2.417ZM29.298 20.299a3.046 3.046 0 0 0-1.797.611 3.018 3.018 0 0 1 0 4.834 3.028 3.028 0 1 0 1.797-5.445Z",
    fill: "#65C1B5"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Credit_Card_svg__a",
    x1: 62.19,
    y1: -62.133,
    x2: 62.19,
    y2: 69.548,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#273A9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#202F65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#021E2F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Credit_Card_svg__b",
    x1: 52.243,
    y1: 19.349,
    x2: 52.243,
    y2: 37.729,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#273A9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#202F65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#021E2F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Credit_Card_svg__c",
    x1: 56.152,
    y1: 16.689,
    x2: 56.152,
    y2: 35.069,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#273A9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#202F65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#021E2F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Credit_Card_svg__d",
    x1: 60.088,
    y1: 13.994,
    x2: 60.088,
    y2: 32.373,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#273A9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#202F65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#021E2F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Credit_Card_svg__e",
    x1: 64.024,
    y1: 11.298,
    x2: 64.024,
    y2: 29.678,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#273A9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#202F65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#021E2F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Credit_Card_svg__f",
    x1: -14.174,
    y1: 17.783,
    x2: 5.733,
    y2: 47.643,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#51D1C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#268C7E"
  })))));
};
export default SvgCreditCard;